import { Axios } from 'utils'
import {
  ItemResponseType,
  ListPaginationParams,
  ListResponseType,
} from './types'
import { TBakersProduct } from 'types/models/BakersProducts'

export const useBakersProductsService = () => {
  const getBakersProducts = async (pagination?: ListPaginationParams) => {
    try {
      const response = await Axios.get<ListResponseType<TBakersProduct>>(
        '/baker/products',
        {
          params: pagination
            ? {
                offset: pagination.currentPage * pagination.itemsPerPage,
                limit: pagination.itemsPerPage,
              }
            : undefined,
        }
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const createBakersProduct = async (params: TBakersProduct) => {
    try {
      const response = await Axios.post<ItemResponseType<TBakersProduct>>(
        '/baker/products',
        params
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const updateBakersProduct = async (params: TBakersProduct) => {
    try {
      const response = await Axios.put<ItemResponseType<TBakersProduct>>(
        `/baker/products/${params.id}`,
        params
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const getBakersProductById = async (id: string) => {
    try {
      const response = await Axios.get<ItemResponseType<TBakersProduct>>(
        `/baker/products/${id}`
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  const deleteBakersProduct = async (id: number) => {
    try {
      const response = await Axios.delete<{ status: boolean; detail: string }>(
        `/baker/products/${id}`
      )
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    getBakersProducts,
    createBakersProduct,
    updateBakersProduct,
    getBakersProductById,
    deleteBakersProduct,
  }
}
